import { render, staticRenderFns } from "./addBlackListTip.vue?vue&type=template&id=2e39927e&scoped=true"
import script from "./addBlackListTip.vue?vue&type=script&lang=js"
export * from "./addBlackListTip.vue?vue&type=script&lang=js"
import style0 from "./addBlackListTip.vue?vue&type=style&index=0&id=2e39927e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39927e",
  null
  
)

export default component.exports